import { vroomPostMessageSchema } from './vroom-post-message.schema';
import { VroomPostMessage } from './vroom-post-message.types';

export const parseVroomPostMessage = (data: unknown): VroomPostMessage => {
  const result = vroomPostMessageSchema.safeParse(data);
  if (result.success) {
    return result.data;
  }
  return { type: 'unknown' };
};
